import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
    selector: "mobile-tooltip",
    templateUrl: "./mobile-tooltip.component.html",
    styleUrls: ["./mobile-tooltip.component.scss"],
    imports: [NgClass],
    standalone: true
})
export class MobileToolTipComponent  {
    // Input Variables
    @Input() content: boolean;
    @Input() icon: string = '?';
    @Input() withBottomSpacing: boolean = false;

    constructor(
       
    ) {
    }

}
